export default "/images/vendor/flag-icon-css/flags/1x1/it.svg?9938f4b9588502f93b20243ed3a5b60c";